import { z } from "zod";
import { http } from "@/shared/api/axios";

export const CreateOrgRequest = z.object({
    name: z.string(),
    domain: z.string(),
    // The plan the customer picked. Required by the API: the account row and the choice are written in
    // one transaction, so the trial starts inside that plan's caps rather than on an unlimited one.
    planCode: z.string(),
    billingInterval: z.enum(["Monthly", "Annual"]),
});

export type CreateOrgRequestType = z.infer<typeof CreateOrgRequest>;

export const CreateOrgResponse = z.object({
    accountId: z.number(),
    name: z.string(),
    domain: z.string(),
});

export type CreateOrgResponseType = z.infer<typeof CreateOrgResponse>;

export async function createOrg(data: CreateOrgRequestType) {
    const res = await http.post("/v1/orgs", data);
    return CreateOrgResponse.parse(res.data);
}
